import { render } from "./prestationTemplate.vue?vue&type=template&id=7ea06689&scoped=true"
import script from "./prestationTemplate.vue?vue&type=script&lang=js"
export * from "./prestationTemplate.vue?vue&type=script&lang=js"

import "./prestationTemplate.vue?vue&type=style&index=0&id=7ea06689&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea06689"]])

export default __exports__